import {sendRequest} from '@js/utils';
import {getRankingId, refreshRankingPage} from '@js/modules/public/rankings/institutional/view/helpers';

export default function initAutocomplete($autocompleteInput) {
    $(window)
        .scroll(() => {
            $autocompleteInput.autocomplete('hide');
        });
    const organizationTypeSelect = $('.ranking-filters [name=is_fil]');
    const yearSelect = $('.ranking-filters [name=year]');
    const requestData = {
        spr_ranking_id: getRankingId(),
        is_fil: organizationTypeSelect.length ? organizationTypeSelect.val() : '',
        year: yearSelect.length ? yearSelect.val() : null,
    };
    sendRequest('get', '/ratings/getVuzAutocompleteSuggests', requestData, (res) => {
        const success = typeof res !== 'undefined' && res.hasOwnProperty('success') && res.success;
        if (success && res.data.suggests) {
            const autocompleteValues = res.data.suggests;
            $autocompleteInput.autocomplete({
                minChars: 2,
                width: 500,
                lookup: autocompleteValues,
                triggerSelectOnValidInput: false,
                onSelect() {
                    const $form = $(this).closest('.ranking-filters');
                    console.log($form);
                    if ($form.attr('id') !== 'modal-filter-form') {
                        refreshRankingPage();
                    }
                },
            });
        }
    });
}
